import { render, staticRenderFns } from "./discovery.vue?vue&type=template&id=78c5fdce&scoped=true&"
import script from "./discovery.vue?vue&type=script&lang=js&"
export * from "./discovery.vue?vue&type=script&lang=js&"
import style0 from "./discovery.vue?vue&type=style&index=0&id=78c5fdce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5fdce",
  null
  
)

export default component.exports